var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34546 2.28832L8.19423 7.16927C8.89176 7.72483 9.08866 7.91106 9.44423 8.0026C9.79979 8.09415 10.1022 8.08352 10.4164 8.0026C10.7723 7.91098 11.1553 7.64375 11.8053 7.16927L17.6541 2.28832M1.38867 11.6218V4.38374C1.38867 3.31698 1.38867 2.78319 1.59724 2.37574C1.7807 2.01734 2.07323 1.72616 2.43329 1.54354C2.84263 1.33594 3.37888 1.33594 4.45059 1.33594H15.5494C16.6211 1.33594 17.1562 1.33594 17.5655 1.54354C17.9256 1.72616 18.2191 2.01734 18.4025 2.37574C18.6109 2.7828 18.6109 3.31593 18.6109 4.38061V11.6251C18.6109 12.6897 18.6109 13.2221 18.4025 13.6292C18.2191 13.9876 17.9256 14.2793 17.5655 14.4619C17.1566 14.6693 16.6217 14.6693 15.5521 14.6693H4.44744C3.37783 14.6693 2.84223 14.6693 2.43329 14.4619C2.07323 14.2793 1.7807 13.9876 1.59724 13.6292C1.38867 13.2217 1.38867 12.6886 1.38867 11.6218Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.069b6f1ce46fb13546a34aa58264c1fb.svg";
export { ForwardRef as ReactComponent };